module.exports = __webpack_public_path__ + "static/media/camera-color-icon.66bc1540.svg";